/*eslint-disable */
const $ = window.jQuery = require('jquery');

import {
  Email,
  Facebook,
  Google,
  Linkedin,
  Pinterest,
  Reddit,
  Telegram,
  Twitter,
  WhatsApp
} from "vue-socialmedia-share";

import {
  mapGetters
} from 'vuex';
import toast from '@/services/toast';

export default {
  name: 'private-blog-details',
  components: {
    Facebook,
    Twitter,
    Linkedin,
    Pinterest,
    Reddit,
    Telegram,
    WhatsApp,
    Email,
    Google
  },
  props: [],
  data () {
    return {
      singleBlogDetails:null,
      url:'',
      publicBlogListState:{},
      publicBlogListResults:[],
      dataFileCode:'',
      renderDataFile:'',
      currentUserId:'',
      getBlogVoteInfo:null,
      isSubmitted:false,
      blogId:''
    }
  },
  computed: {
    ...mapGetters([
      'blogDetailsByIdGetters',
      'suggestionBlogListGetters',,
      'getBlogVoteInfoGetters'
    ]),
    getBlogVoteInfoFun(){
      this.getBlogVoteInfo = this.$store.getters.getBlogVoteInfoGetters.data
      return
    },
    getBlogDetailsAgainFun(){
      this.singleBlogDetails = this.$store.getters.blogDetailsByIdGetters.response
      return
    },
    getPubBlogListFun(){
      this.publicBlogListState = this.$store.getters.suggestionBlogListGetters.data
      return
    },
    setInitialPubBlogStates(){
      if(this.publicBlogListState != undefined){
        this.publicBlogListResults = this.publicBlogListState.results
      }
    },
    setInitialBlogDetailsState() {
      this.dataFileCode = ''
      if(this.singleBlogDetails){
        this.renderDataFile = this.singleBlogDetails.data_file
        this.getDataFromDataFileMethod(this.renderDataFile)
      }
    },
  },
  mounted () {
    this.currentUserId = localStorage.getItem('LoginedUserID');
    this.blogId = this.$route.params.blogId
    this.getBlogDetailsAgainFun
    this.url = window.location.href
    this.getPubBlogListFun
    this.setInitialPubBlogStates
    this.setInitialPubBlogStates
    this.getBlogVoteInfoFun
  },
  created () {
    document.addEventListener('scroll', this.updateScrollBar);
    window.addEventListener('resize', this.updateScrollBar);
  },
  destroyed () {
    document.removeEventListener('scroll', this.updateScrollBar);
    window.removeEventListener('resize', this.updateScrollBar);
  },
  methods: {
    updateScrollBar() {
      var doc = document.documentElement;
      var win = window;
      var scrollTop = (doc && doc.scrollTop) || (document.body && document.body.scrollTop);
      var scrollHeight = (doc && doc.scrollHeight) || (document.body && document.body.scrollHeight);
      var clientHeight = doc ? doc.clientHeight : document.body.clientHeight;
      var scrollPercent = scrollTop / (scrollHeight - clientHeight) * 100;
      var scrollBar = document.getElementById('scroll-bar');
      scrollBar.style.width = scrollPercent + '%';
    },
    upVoteBlog(vote){
      let voted = true;
      if(vote){
        voted = false
      }else{
        voted = true
      }
      let data = {
        user : this.currentUserId,
        blog: this.blogId,
        upvote:voted
      }
      this.isSubmitted = true
      this.$store.dispatch('blogVoteAction', data).then((res) => {
        this.$store.dispatch('getBlogVoteInfoAction', { id: this.blogId })
        this.isSubmitted = false
      }).catch((err) => {
        this.isSubmitted = false
        toast.error(err.data.data.non_field_errors[0] || err.data.msg);
      })
    },
    downVoteBlog(vote){
      let voted = true;
      if(vote){
        voted = false
      }else{
        voted = true
      }
      let data = {
        user : this.currentUserId,
        blog: this.blogId,
        downvote:voted
      }
      this.isSubmitted = true
      this.$store.dispatch('blogVoteAction', data).then((res) => {
        this.$store.dispatch('getBlogVoteInfoAction', { id: this.blogId })
        this.isSubmitted = false
      }).catch((err) => {
        this.isSubmitted = false
        toast.error(err.data.data.non_field_errors[0] || err.data.msg);
      })
    },
    neutralVoteBlog(vote){
      let voted = true;
      if(vote){
        voted = false
      }else{
        voted = true
      }
      let data = {
        user : this.currentUserId,
        blog: this.blogId,
        neutral:voted
      }
      this.isSubmitted = true
      this.$store.dispatch('blogVoteAction', data).then((res) => {
        this.$store.dispatch('getBlogVoteInfoAction', { id: this.blogId })
        this.isSubmitted = false
      }).catch((err) => {
        this.isSubmitted = false
        toast.error(err.data.data.non_field_errors[0] || err.data.msg);
      })
    },
    getDataFromDataFileMethod(fileUrl) {
      var __self = this
      fetch(fileUrl)
        .then(function (response) {
          switch (response.status) {
            // status "OK"
            case 200:
              return response.text();
            // status "Not Found"
            case 404:
              throw response;
          }
        })
        .then(function (template) {
          __self.dataFileCode = template
        })
        .catch(function (response) {
        });
    }
  },
  watch:{
    getBlogDetailsAgainFun(){
      return this.$store.getters.blogDetailsByIdGetters
    },
    setInitialBlogDetailsState() {
      if(this.singleBlogDetails){
        this.renderDataFile = this.singleBlogDetails.data_file
      }
    },
    getPubBlogListFun(){
      return this.$store.getters.suggestionBlogListGetters
    },
    setInitialPubBlogStates(){
      if(this.publicBlogListState != undefined){
        this.publicBlogListResults = this.publicBlogListState.results
      }
    },
    getBlogVoteInfoFun(){
      return this.$store.getters.getBlogVoteInfoGetters
    },
  },
  beforeCreate: function() {
  },
  beforeRouteLeave: function(to, from, next) {
    next();
  },
}